export const BASE_URL = 'https://posapi.mahfuzshahin.com';

export const ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/login',
    REGISTER: '/api/register',
  }
};